export default __webpack_public_path__ + "static/media/banner2.fc66a5a5.jpg";